import React from 'react';
import { Divider } from '@mui/material';
import OperatorEfficiencyChart from './OperatorEfficiencyChart';
import OperatorPaySheets from './OperatorPaySheets';

const GeneralInfo = ({ data, paySheetsData, classes }) => {
    if (!data) return null;

    return (
        <div className={classes.generalInfoCard}>
            <OperatorEfficiencyChart 
                paySheetsData={paySheetsData}
                classes={classes} 
            />
            <Divider style={{ margin: '24px 0' }} />
            <OperatorPaySheets 
                paySheetsData={paySheetsData}
                classes={classes} 
            />
        </div>
    );
};

export default GeneralInfo;

